import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useModifyAnExchange } from './useModifyAnExchange';
import { Button } from '@homeexchange/panorama';
import i18n from '../../../i18n';
import { fetchConversation } from '../../../actions/conversations';
export var ButtonModifyAnExchange = function (_a) {
    var conversation = _a.conversation, user = _a.user, isFullWidth = _a.isFullWidth;
    var dispatch = useDispatch();
    var availabilities = useSelector(function (state) { return state.availabilities[conversation.getExchange().get('home').id]; });
    var interlocutorAvailabilities = useSelector(function (state) {
        return conversation.isMutual() ? state.availabilities[conversation.getExchangeAsHost().get('home').id] : [];
    });
    var _b = useModifyAnExchange({
        conversation: conversation,
        availabilities: availabilities,
        user: user,
        interlocutorAvailabilities: interlocutorAvailabilities,
        fetchConversation: function () { return dispatch(fetchConversation); }
    }), isLoading = _b.isLoading, canModify = _b.canModify, showModifyExchangeModal = _b.showModifyExchangeModal, conversationHasModification = _b.conversationHasModification;
    return (canModify() && (React.createElement(Button, { isFullWidth: isFullWidth, onClick: showModifyExchangeModal, isDisabled: conversationHasModification, isLoading: isLoading }, i18n.t('exchange:modify-exchange.action-modify-exchange'))));
};
